import * as React from 'react';
import classNames from 'classnames';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import PageContent from 'src/components/PageContent';

import * as pageDetailsActions from './actions';

import IMPComponent from 'src/components/interfaces/IMPComponent';

import PATHS from '../../../../constants/paths';

import './styles.scss';
import { PagePreviewType, PageToolbar } from '../../../../components/PageToolbar';
import { PageInsights } from '../../PageInsights/';
import { Page, SubscriptionState } from '../../../../Models';

export interface IPageDetailsProps extends IMPComponent {
  readonly page: Page;
  readonly subscriptionState: SubscriptionState | null;
}

interface IPageDetailMethods {
  confirmPagesHistoryDeletePage: any;
}

const enhance = compose<any, IPageDetailsProps & IPageDetailMethods & InjectedIntlProps>(
  withRouter,
  injectIntl,
  connect(
    null,
    pageDetailsActions,
  ),
);

interface PageDetailsState {
  readonly previewType: PagePreviewType;
}

class PageDetails extends React.PureComponent<
  IPageDetailsProps & RouteComponentProps & IPageDetailMethods & InjectedIntlProps,
  PageDetailsState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      previewType: PagePreviewType.text,
    };
  }

  public render() {
    const { className, style, page } = this.props;
    const cn = classNames('PageDetails', className);

    return (
      <div className={cn} style={style}>
        <PageToolbar
          onChangePreviewType={this.handleChangePreviewType}
          onEdit={this.handleEdit}
          onDelete={this.handleDelete}
        />
        {this.state.previewType === PagePreviewType.text ? <PageContent {...page} /> : <PageInsights {...this.props} />}
      </div>
    );
  }

  private handleEdit = () => {
    const {
      page: { dateId },
      history,
    } = this.props;

    history.push(`${PATHS.PAGES.EDIT}/${dateId}`);
  };

  private handleDelete = () => {
    const {
      intl: { formatMessage },
      page: { dateId },
      confirmPagesHistoryDeletePage,
    } = this.props;

    const promptMessage = formatMessage({
      id: 'containers.PagesHistory.PagesHistoryHome.PageDetails.deletePrompt',
    });

    if (confirm(promptMessage)) {
      confirmPagesHistoryDeletePage(dateId);
    }
  };

  private handleChangePreviewType = (type: PagePreviewType) => {
    this.setState({
      previewType: type,
    });
  };
}

export default enhance(PageDetails);



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/PagesHistoryHome/PageDetails/index.tsx